// register form start
jQuery(document).ready(function ($) {
  let intervalId;
  // Function to start the OTP timer
  function startOTPTimer(duration = 59) {
    let seconds = duration; // Start with 59 seconds

    function updateTimerDisplay() {
      const timerElement = document.getElementById("timer");
      timerElement.textContent = `${seconds}s`;
    }

    updateTimerDisplay();

    intervalId = setInterval(function () {
      if (seconds === 0) {
        clearInterval(intervalId);
        $('.register-verify-form .position-relative .not-recived-code #timer').addClass("d-none");
        $('.register-verify-form .position-relative .not-recived-code a').removeClass("d-none");
        // Timer has reached 0s, handle your action here (e.g., resend OTP)
        return;
      }
      seconds--;
      updateTimerDisplay();
    }, 1000);
  }

  $('#TogglePasswordVisibility').click(function () {

    if ($('#password-input').length) {
      var passwordInput = $('#password-input');
      var currentType = passwordInput.attr('type');
    } else {
      var passwordInput = $('.form-layouts .position-relative #RegisterForm-password');
      var currentType = passwordInput.attr('type');
    }

    if (currentType === 'password') {
      passwordInput.attr('type', 'text');
      $('#eye-close-icon').hide();
      $('#eye-icon').show();
    } else {
      passwordInput.attr('type', 'password');
      $('#eye-close-icon').show();
      $('#eye-icon').hide();
    }
  });

  $('#TogglePasswordCpassword').click(function () {
    var passwordInput = $('.form-layouts .position-relative #c_password');
    var currentType = passwordInput.attr('type');

    if (currentType === 'password') {
      passwordInput.attr('type', 'text');
      $('#eye-close-icon-cpassword').hide();
      $('#eye-icon-cpassword').show();
    } else {
      passwordInput.attr('type', 'password');
      $('#eye-close-icon-cpassword').show();
      $('#eye-icon-cpassword').hide();
    }
  });
  $('.regi-login-btn.get-otp').click(function () {
    var response
    event.preventDefault();
    if ($('#captcha-container').length > 0) {
      response = grecaptcha.getResponse();
      if (response.length == 0) {
        alert("Please complete the CAPTCHA.");
        return;  // If CAPTCHA is not completed, stop the process
      } else {
        // If CAPTCHA is valid, reset and remove the widget
        grecaptcha.reset();  // This clears the CAPTCHA response
        $('#captcha-container').remove();  // This removes the CAPTCHA from the page
      }
    }

    $('.regi-login-btn.get-otp').find('div:first').addClass('d-none');
    $('#loader-otp').css("display", "inline-block");
    //get-otp api call strat
    var flagcode = $('#flag-with-code').val();
    var phNo = $('#mobile-number').val();
    var mobile_number = flagcode + phNo;
    mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");
    if (flagcode && phNo) {
      var inputdata = {
        mobile: mobile_number,
        captchaToken: response || ''
      }

      $.ajax({
        url: 'https://app.ian.ng/api/send-otp-test',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(inputdata),
        success: function (result) {
          // Handle the response data here
          if (result.statusCode == 200 && result.status == 'success') {
            console.log("success");
            const interval = result.data?.[0]?.interval_between_requests || 59;
            // Call the startOTPTimer function to start the timer
            startOTPTimer(interval);
            $('.register-verify-form .position-relative .not-recived-code').removeClass("d-none");
            $(".register-verify-form .regi-login-btn.verify").removeClass("d-none");
            $('.register-verify-form .phone-number-error.otp-verify').addClass("d-none");
            $('.register-page-card .register-page-card-header .otp-verify-title').removeClass("d-none");
            $('.register-page-card .register-page-card-header .create_account_on_verify_page').addClass("d-none");
            $(".register-verify-form .position-relative.phone-number-verify").addClass("d-none");
            $(".register-verify-form .regi-login-btn.get-otp").addClass("d-none");
            $(".register-verify-form .position-relative.otp-verify").removeClass("d-none");
            $(".register-verify-form .regi-login-btn.verify").removeClass("d-none");
            $('.regi-login-btn.get-otp').find('div:first').removeClass('d-none');
            $('#loader-otp').css("display", "none");
            $('.register-page-container .register-page-card.mt-1').addClass('d-none');
          } else {
            $('.regi-login-btn.get-otp').find('div:first').removeClass('d-none');
            $('#loader-otp').css("display", "none");
            $(".register-verify-form .phone-number-error.phone-number-verify")
              .removeClass('d-none')
              .find('.error-text')
              .html(result.message)
            $('.register-verify-form .phone-number-error.otp-verify')
              .removeClass('d-none')
              .find('.error-text')
              .html(result.message);
            $('.register-verify-form .position-relative .not-recived-code').addClass("d-none");
            $(".register-verify-form .regi-login-btn.verify").addClass("d-none");
          }
        },
        error: function (result) {
          console.log(result);
          //$('.phone-number-error').after('<div id="captcha-error" class="captcha-error">Invalid captcha</div>');
          $('.regi-login-btn.get-otp').find('div:first').removeClass('d-none');
          $('#loader-otp').css("display", "none");
          $(".register-verify-form .phone-number-error.phone-number-verify")
            .removeClass('d-none')
            .find('.error-text')
            .html(result.message);
        }
      });
    } else {
      $('.regi-login-btn.get-otp').find('div:first').removeClass('d-none');
      $('#loader-otp').css("display", "none");
      $(".register-verify-form .phone-number-error.phone-number-verify").removeClass("d-none");
      $(".register-verify-form .phone-number-error .error-container .error").addClass("d-none");
      $(".register-verify-form .phone-number-error .error-container .empty-number").removeClass('d-none');
      $('#mobile-number').focus();
    }
    //get-otp end
  });

  $('.register-page-card .register-verify-form .position-relative .not-recived-code a').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    // clearInterval(intervalId);
    // startOTPTimer();
    $('.regi-login-btn.get-otp').trigger('click');
    $('.register-verify-form .position-relative .not-recived-code #timer').removeClass("d-none");
    $('.register-verify-form .position-relative .not-recived-code a').addClass("d-none");
  });

  $('.register-verify-form .phone-number-error.otp-verify a').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    // startOTPTimer();
    $('.register-verify-form .phone-number-error.otp-verify').addClass("d-none");
    $('.register-verify-form .position-relative .otp-input .otp-number').removeClass("otp-error");
  });

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }
  function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }

  $('.register-page-card .regi-login-btn.verify').click(function () {
    $('.register-page-card .regi-login-btn.verify').find('div:first').addClass('d-none');
    $('#loader-verify').css("display", "inline-block");
    //verify-otp api call start
    var otp_no1 = $('#number0').val();
    var otp_no2 = $('#number1').val();
    var otp_no3 = $('#number2').val();
    var otp_no4 = $('#number3').val();
    var flagcode = $('#flag-with-code').val();
    var phNo = $('#mobile-number').val();
    var mobile_number = flagcode + phNo
    mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");

    var vrifydata = {
      mobile: mobile_number,
      otp: otp_no1 + otp_no2 + otp_no3 + otp_no4,
    }
    $.ajax({
      url: 'https://app.ian.ng/api/verify-otp-test',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(vrifydata),
      success: function (result) {
        // Handle the response data here
        if (result.statusCode == 200 && result.status == 'success') {
          console.log(result, 'result')
          let verfiyMobileData = result?.data;
          setCookie("mobileNumber", mobile_number, 30);
          $(".register-page-card-header .otp-verify-title").addClass("d-none");
          $(".register-verify-form .position-relative.otp-verify").addClass("d-none");
          $(".register-verify-form .regi-login-btn.verify").addClass("d-none");
          $(".register-page-card-header .create_account_on_verify_page").addClass("d-none");
          $(".register-page-card-header .registartion_customer_form").removeClass("d-none");
          $(".register-page-bg-img").addClass("d-none");
          $(".register-page-card-body .form-layouts").removeClass("d-none");
          $(".register-page-content .register-page-card").addClass("register-form-card");
          $('.register-page-card .regi-login-btn.verify').find('div:first').removeClass('d-none');
          $('#loader-verify').css("display", "none");
          if (verfiyMobileData?.mobile) {
            let genderData = (verfiyMobileData?.gender == 'M') ? 'Male' : 'Female';
            $(".register-page-card-body .form-layouts #RegisterForm-FirstName").val(verfiyMobileData?.name);
            $(".register-page-card-body .form-layouts #RegisterForm-gender").val(genderData);
            if ($(".register-page-card-body .form-layouts #RegisterForm-gender").val()) {
              $(".register-page-card-body .form-layouts #select2-RegisterForm-gender-container").text(genderData);
            }
            $(".register-page-card-body .form-layouts #RegisterForm-datepicker").val(verfiyMobileData?.DOB);
            $(".register-page-card-body .form-layouts #RegisterForm-race").val(verfiyMobileData?.race);
            if ($(".register-page-card-body .form-layouts #RegisterForm-race").val() != null) {
              $(".register-page-card-body .form-layouts #select2-RegisterForm-race-container").text(verfiyMobileData?.race);
            }

          }
        } else {
          $('.register-page-card .regi-login-btn.verify').find('div:first').removeClass('d-none');
          $('#loader-verify').css("display", "none");
          // $('.register-verify-form .position-relative .not-recived-code').addClass("d-none")
          $('.register-verify-form .phone-number-error.otp-verify')
            .removeClass('d-none')
            .find('.error-text')
            .html(result.message)
          $('.register-verify-form .position-relative .otp-input .otp-number').addClass("otp-error");
        }
      },
      error: function (result) {
        $('.register-page-card .regi-login-btn.verify').find('div:first').removeClass('d-none');
        $('#loader-verify').css("display", "none");
        $('.register-verify-form .phone-number-error.otp-verify')
          .removeClass('d-none')
          .find('.error-text')
          .html(result.message)
        $('.register-verify-form .position-relative .otp-input .otp-number').addClass("otp-error");
      }
    })
    //verify-otp api call end

  });

  $('#mobile-number').on('input', function () {
    $(this).val($(this).val().replace(/[^0-9]/g, ''));
  });

  $('.otp-number').on('input', function () {
    // Remove non-numeric characters
    $(this).val($(this).val().replace(/[^0-9]/g, ''));

    // Move to the next input field if a numeric character is entered
    if ($(this).val().length === 1) {
      $(this).next('.otp-number').focus();
    }

    if ($(this).val().length !== 1) {
      $(this).prev('.otp-number').focus();
    }
  });

  $('.intl-tel-input').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    $('.selected-flag').trigger('click');
  });

  // Function to calculate age based on DOB
  function calculateAge(date_of_birth) {
    var today = new Date();
    let newDate = date_of_birth.split('/');
    newDate = `${newDate[1]}/${newDate[0]}/${newDate[2]}`;
    var birthDate = new Date(newDate);

    var age = today.getFullYear() - birthDate.getFullYear();
    var monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age;
    }
    return age;
  }

  $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').click(function (event) {
    $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').addClass('d-none');
    $('#loader-submit').css("display", "inline-block");
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    var form = $(this).closest("form");
    var name = form.find('#RegisterForm-FirstName').val();
    var email = form.find('#RegisterForm-email').val();
    var psw = form.find('#RegisterForm-password').val();
    var cpsw = form.find('#c_password').val();
    var gender = form.find('#RegisterForm-gender').val();
    var date_of_birth = form.find('#RegisterForm-datepicker').val();
    var race = form.find('#RegisterForm-race').val();
    var opt_email = form.find('#RegisterForm-opt-email').is(":checked");
    var opt_sms = form.find('#RegisterForm-opt-sms').is(":checked");
    var phoneNumber = getCookie("mobileNumber"); // phone number that verify
    var checkPasswordHasClass = form.find(".password-google-login-hide").hasClass('d-none');
    var f_psw = psw == cpsw;
    var userAge = calculateAge(date_of_birth);

    if (f_psw == false && !checkPasswordHasClass) {
      $('.register-page-card-body .form-layouts .reg-mismatch-psw').removeClass("d-none");
    } else {
      $('.register-page-card-body .form-layouts .reg-mismatch-psw').addClass("d-none");
    }

    if (name && email && ((psw && cpsw) || checkPasswordHasClass) && gender && date_of_birth && race && phoneNumber && f_psw == true) {
      var data = {
        phone: phoneNumber,
        name: name,
        email: email,
        gender: gender,
        dob: date_of_birth,
        race: race,
        opt_email: (opt_email == true) ? '1' : '0',
        opt_sms: (opt_sms == true) ? '1' : '0',
        login_type: '0'
      };
      if (checkPasswordHasClass) {
        data.login_type = '1';
      }
      if (userAge >= 21) {
        $.ajax({
          url: 'https://app.ian.ng/api/registration-member',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(data),
          success: function (result) {
            if (result.status == "success") {
              if (checkPasswordHasClass) {
                console.log(result);
                form.find('#RegisterForm-password').val(result?.data?.password);
                form.find('#c_password').val(result?.data?.password);
                form.find('#RegisterForm-FirstName').prop('disabled', false);
                form.find('#RegisterForm-email').prop('disabled', false);
              }
              form.submit()
              $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
              $('#loader-submit').css("display", "none");
            } else if (result.status == "error" && result.message == "email exits!") {
              $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
              $('#loader-submit').css("display", "none");
              $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");

              // ========== OLD REGISTRATION ERROR HANDLING ==========
              // }else{
              //   $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
              //   $('#loader-submit').css("display", "none");
              //   $('.register-page-card-body .form-layouts .something-went-wrong').removeClass("d-none");
              // }
              // ========== END OLD REGISTRATION ERROR HANDLING ==========

              // ========== NEW REGISTRATION ERROR HANDLING ==========
            } else {
              console.error('Registration API error:', result);
              $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
              $('#loader-submit').css("display", "none");
              $('.register-page-card-body .form-layouts .something-went-wrong')
                .removeClass("d-none")
                .find('.error-text')
                .html(result.message || 'Something went wrong, please try again.');
            }
            // ========== END NEW REGISTRATION ERROR HANDLING ==========
          },

          // ========== OLD REGISTRATION AJAX ERROR HANDLER ==========
          // error: function(result) {
          //   $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
          //   $('#loader-submit').css("display", "none");
          //    $('.register-page-card-body .form-layouts .something-went-wrong').removeClass("d-none");
          // }
          // ========== END OLD REGISTRATION AJAX ERROR HANDLER ==========

          // ========== NEW REGISTRATION AJAX ERROR HANDLER ==========
          error: function (result) {
            console.error('Registration API failure:', result);
            $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
            $('#loader-submit').css("display", "none");
            $('.register-page-card-body .form-layouts .something-went-wrong')
              .removeClass("d-none")
              .find('.error-text')
              .html(result?.responseJSON?.message || 'Something went wrong, please try again.');
          }
          // ========== END NEW REGISTRATION AJAX ERROR HANDLER ==========
        });
      } else {
        $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
        $('#loader-submit').css("display", "none");
        $('.register-page-card-body .form-layouts .reg-mismatch-year').removeClass("d-none");
      }
    } else {
      $('.register-page-card .register-page-card-body .form-layouts .submit-btn .customer-register').find('div:first').removeClass('d-none');
      $('#loader-submit').css("display", "none");
      if (!phoneNumber) {
        // Phone number cookie missing — session may have expired, redirect back to start
        console.error('mobileNumber cookie is missing. Restarting registration flow.');
        $('.register-page-card-body .form-layouts .something-went-wrong')
          .removeClass("d-none")
          .find('.error-text')
          .html('Your session has expired. Please <a href="">refresh the page</a> and verify your phone number again.');
      }
      if (name == '') {
        $('.register-page-card-body .form-layouts .position-relative #RegisterForm-FirstName').addClass("otp-error").focus();
        $('.register-page-card-body .form-layouts .position-relative .f-name').removeClass("d-none");
      }
      if (email == '') {
        $('.register-page-card-body .form-layouts .position-relative #RegisterForm-email').addClass("otp-error");
        $('.register-page-card-body .form-layouts .form-items .reg-email').removeClass("d-none");
      }
      if (psw == '' && !checkPasswordHasClass) {
        $('.register-page-card-body .form-layouts .position-relative #RegisterForm-password').addClass("otp-error");
        $('.register-page-card-body .form-layouts .form-items .reg-password').removeClass("d-none");
      }
      if (cpsw == '' && !checkPasswordHasClass) {
        $('.register-page-card-body .form-layouts .position-relative #c_password').addClass("otp-error");
        $('.register-page-card-body .form-layouts .form-items .reg-Cpassword').removeClass("d-none");
      }
      if (gender == null) {
        $('.register-page-card-body .form-layouts .position-relative#select-gender').addClass("error-border");
        $('.register-page-card-body .form-layouts .form-items .reg-gender').removeClass("d-none");
      }
      if (date_of_birth == '') {
        $('.register-page-card-body .form-layouts .position-relative #RegisterForm-datepicker').addClass("otp-error");
        $('.register-page-card-body .form-layouts .form-items .reg-dob').removeClass("d-none");
      }
      if (race == null) {
        $('.register-page-card-body .form-layouts .position-relative#select-race').addClass("error-border");
        $('.register-page-card-body .form-layouts .form-items .reg-race').removeClass("d-none");
      }
    }
  });

  function formatDate(dateString) {
    var date = new Date(dateString);

    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var day = date.getDate();
    var month = months[date.getMonth()];
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();

    var dayWithSuffix = day + (
      (day % 10 === 1 && day !== 11) ? 'st' :
        (day % 10 === 2 && day !== 12) ? 'nd' :
          (day % 10 === 3 && day !== 13) ? 'rd' : 'th'
    );
    var time = hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
    var formattedDate = month + ' ' + dayWithSuffix + ' ' + year + ', ' + time;
    return formattedDate;
  }

  console.log(__st.pageurl);
  if (__st.pageurl.split('/')[1] === 'account') {
    if (__st.cid) {
      var customer_id = __st.cid;
      $.ajax({
        url: 'https://app.ian.ng/api/my-points',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ customerId: customer_id }),
        success: function (result) {
          if (result.status == "success") {
            var tableBody = $(".my-points-page table tbody");
            tableBody.empty();
            var mobilePhonePointData = $(".my-points-page .mob-points-tables .points-tables-container");
            mobilePhonePointData.empty();
            result.data.forEach(function (item) {
              // for desktop
              var row = $("<tr>");
              row.append("<td>" + formatDate(item?.TrxDate) + "</td>");
              row.append("<td>" + item?.Outlet + "</td>");
              row.append("<td>" + "Invoice " + item?.InvoiceNo + "</td>");
              row.append("<td>" + item?.TrxDesc + "</td>");
              row.append("<td>" + "RM" + item?.Amount + "</td>");
              row.append("<td>" + "+" + item?.Point + " Points" + "</td>");
              tableBody.append(row);

              // for mobile
              var contentBlock = $("<div>").addClass("points-tables-sec");
              contentBlock.append("<div class='points-tables-details'> <div class='points-detail-content'><h2>Date</h2><p>" + formatDate(item.TrxDate) + "</p></div> <div class='points-detail-content'><h2>Amount</h2><p>RM" + item.Amount + "</p></div><div class='points-detail-content'><h2>Outlet Name</h2><p>" + item.Outlet + "</p></div><div class='points-detail-content'><h2>Invoice Name</h2><p> Invoice " + item.InvoiceNo + "</p></div><div class='points-detail-content'><h2>Point Update Type</h2><p>" + item.TrxDesc + "</p></div><div class='points-detail-content'><h2>Point Movement</h2><p>+" + item.Point + " Points</p></div></div>");
              mobilePhonePointData.append(contentBlock);
            });
          } else {
            var tableBody = $(".my-points-page table tbody");
            var nodata = $("<div class='points-no-data'>No data found</div>");
            $(".my-points-page table").addClass("table-no-found");
            tableBody.addClass('tble-no-data-found');
            tableBody.append(nodata);
            var mobilePhonePointData = $(".my-points-page .mob-points-tables .points-tables-container .points-tables-sec");
            var contentBlock = $("<div>").addClass("points-tables-details");
            $(".my-points-page .mob-points-tables .points-tables-container").addClass("no-data-found");
            contentBlock.append("<div><h2>No Data Found</h2></div>");
            mobilePhonePointData.append(contentBlock);
          }
        }, error: function (result) {
          var tableBody = $(".my-points-page table tbody");
          var nodata = $("<div class='points-no-data'>No data found</div>");
          $(".my-points-page table").addClass("table-no-found");
          tableBody.addClass('tble-no-data-found');
          tableBody.append(nodata);
          var mobilePhonePointData = $(".my-points-page .mob-points-tables .points-tables-container .points-tables-sec");
          var contentBlock = $("<div>").addClass("points-tables-details");
          $(".my-points-page .mob-points-tables .points-tables-container").addClass("no-data-found");
          contentBlock.append("<div><h2>No Data Found</h2></div>");
          mobilePhonePointData.append(contentBlock);
        }
      });
      $.ajax({
        url: 'https://app.ian.ng/api/check-balance',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ customer_id: customer_id }),
        success: function (result) {
          if (result.status == "success" && result.statusCode == 200) {
            var balance = result.data.balance;
            $('.account-profile-dashboard .account-dashboard-card .phara-member-id-num .mem-number-id').text(balance + "pts");
            $('.account-pharamcy-card .paharamcy-member-card .phara-member-pts p').text(balance + "pts");
          } else {
            $('.account-profile-dashboard .account-dashboard-card .phara-member-id-num .mem-number-id').text('0' + "pts");
            $('.account-pharamcy-card .paharamcy-member-card .phara-member-pts p').text('0' + "pts");
          }
        }, error: function (result) {
          $('.account-profile-dashboard .account-dashboard-card .phara-member-id-num .mem-number-id').text('0' + "pts");
          $('.account-pharamcy-card .paharamcy-member-card .phara-member-pts p').text('0' + "pts");
        }
      });
    }
  }
  $('.my-account-dashboard .account-profile-dashboard .profils-details-form-card .btn-profile-details').click(function (event) {
    let flag = $('.my-account-dashboard .account-profile-dashboard .profils-details-form-card .profile-detail-body .form-items #flag-with-code').val();
    let ph_No = $(".my-account-dashboard .account-profile-dashboard .profils-details-form-card .profile-detail-body .form-items #mobile-number").val();
    var mob_no = flag + ph_No;
    mob_no = mob_no?.replace(/\+/g, "")?.replace(/\s/g, "");
    localStorage.setItem("mobile_number", mob_no)
    $(".RegisterForm-dob input").addClass("disabled-input");
    $(".RegisterForm-email input").addClass("disabled-input");
    $("#name").prop("disabled", false);
    $('.my-account-dashboard .account-profile-dashboard .profils-details-form-card .form-layouts .position-relative.phone-number-verify').removeClass("pointer-event-none")
    $("#mobile-number").prop("disabled", false);
    $("#RegisterForm-gender").prop("disabled", false);
    $("#RegisterForm-race").prop("disabled", false);
    $("#RegisterForm-opt-email").prop("disabled", false);
    $("#RegisterForm-opt-sms").prop("disabled", false);
    $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .profile-cancel-btn').removeClass("d-none");
    $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .regi-login-btn').removeClass("d-none");
  });
  $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .profile-cancel-btn').click(function (event) {
    $("#name").prop("disabled", true);
    $('.my-account-dashboard .account-profile-dashboard .profils-details-form-card .form-layouts .position-relative.phone-number-verify').addClass("pointer-event-none")
    $(".RegisterForm-dob input").removeClass("disabled-input");
    $(".RegisterForm-email input").removeClass("disabled-input");
    $("#mobile-number").prop("disabled", true);
    $("#RegisterForm-gender").prop("disabled", true);
    $("#RegisterForm-race").prop("disabled", true);
    $("#RegisterForm-opt-email").prop("disabled", true);
    $("#RegisterForm-opt-sms").prop("disabled", true);
    $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .profile-cancel-btn').addClass("d-none");
    $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .regi-login-btn').addClass("d-none");
  });

  const loader = $("#loader");
  $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .regi-login-btn').click(function (event) {
    $(".regi-login-btn").find("div:first").addClass("d-none");
    loader.css("display", "inline-block");
    var mob_no = localStorage.getItem('mobile_number');
    var name = $('#name').val();
    // var new_mobno = $("#mobile-number").val();
    var flagcode = $('#flag-with-code').val();
    var phNo = $('#mobile-number').val();
    var mobile_number = flagcode + phNo;
    mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");
    var gender = $('#RegisterForm-gender').val();
    var race = $('#RegisterForm-race').val();
    var opt_email = $("#RegisterForm-opt-email").is(":checked");
    var opt_sms = $("#RegisterForm-opt-sms").is(":checked");
    if (name && flagcode && phNo && gender && race) {
      if (mob_no !== mobile_number) {
        if (flagcode && phNo) {
          var inputdata = {
            mobile: mobile_number,
          }
          $.ajax({
            url: 'https://app.ian.ng/api/send-otp-test',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(inputdata),
            success: function (result) {
              // Handle the response data here
              if (result.statusCode == 200 && result.status == 'success') {
                startOTPTimer();
                $('.my-account-page .popup').removeClass("d-none");
                $('.my-account-page .popup').addClass("show");
                $(".regi-login-btn").find("div:first").removeClass("d-none");
                loader.css("display", "none");
              } else {
                $(".regi-login-btn").find("div:first").removeClass("d-none");
                loader.css("display", "none");
                // $(".register-verify-form .phone-number-error.phone-number-verify").removeClass("d-none");
              }
            },
            error: function (result) {
              $(".regi-login-btn").find("div:first").removeClass("d-none");
              loader.css("display", "none");
              // $(".register-verify-form .phone-number-error.phone-number-verify").removeClass("d-none");
            }
          });
        }
      } else {
        var data = {
          phone: mobile_number,
          name: name,
          gender: gender,
          race: race,
          opt_email: (opt_email == true) ? '1' : '0',
          opt_sms: (opt_sms == true) ? '1' : '0',
          customer_id: __st.cid
        }
        $.ajax({
          url: 'https://app.ian.ng/api/update-details',
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify(data),
          success: function (response) {
            if (response.statusCode == 200 && response.status == 'success') {
              $('.profils-details-form-card .profile-detail-body .form-layouts #name').removeClass("otp-error");
              $('.profils-details-form-card .profile-detail-body .form-layouts .phone-with-country-code').removeClass("error-border");
              $('.profils-details-form-card .profile-detail-body .form-layouts .position-relative#select-gender').removeClass("error-border");
              $('.profils-details-form-card .profile-detail-body .form-layouts .position-relative#select-race').removeClass("error-border");
              localStorage.removeItem("mobile_number");
              $('.account-profile-dashboard .account-dashboard-card-box .account-card-name p').text(name);
              $('.account-pharamcy-card .account-pharamcy-card-sections .member-card-title').text(name);
              $("#name").prop("disabled", true);
              $('.my-account-dashboard .account-profile-dashboard .profils-details-form-card .form-layouts .position-relative.phone-number-verify').addClass("pointer-event-none")
              $("#mobile-number").prop("disabled", true);
              $("#RegisterForm-gender").prop("disabled", true);
              $("#RegisterForm-race").prop("disabled", true);
              $("#RegisterForm-opt-email").prop("disabled", true);
              $("#RegisterForm-opt-sms").prop("disabled", true);
              $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .profile-cancel-btn').addClass("d-none");
              $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .regi-login-btn').addClass("d-none");
              $(".RegisterForm-dob input").removeClass("disabled-input");
              $(".RegisterForm-email input").removeClass("disabled-input");
              $(".regi-login-btn").find("div:first").removeClass("d-none");
              loader.css("display", "none");
            } else {
              $(".my-account-dashboard .account-profile-dashboard .profils-details-form-card .profile-detail-body .mobile-no-error").removeClass("d-none");
              $(".regi-login-btn").find("div:first").removeClass("d-none");
              loader.css("display", "none");
            }
          },
          error: function (error) {
            $(".regi-login-btn").find("div:first").removeClass("d-none");
            loader.css("display", "none");
          }
        });
      }
    } else {
      $(".regi-login-btn").find("div:first").removeClass("d-none");
      loader.css("display", "none");
      if (name == '') {
        $('.profils-details-form-card .profile-detail-body .form-layouts #name').addClass("otp-error");
      }
      if (phNo == '') {
        $('.profils-details-form-card .profile-detail-body .form-layouts .phone-with-country-code').addClass("error-border");
      }
      if (gender == null) {
        $('.profils-details-form-card .profile-detail-body .form-layouts .position-relative#select-gender').addClass("error-border");
      }
      if (race == null) {
        $('.profils-details-form-card .profile-detail-body .form-layouts .position-relative#select-race').addClass("error-border");
      }
    }
  });
  $('.my-account-page .popup .account-otp-modal .submit-btn').click(function (event) {
    $('.my-account-page .popup .account-otp-modal .submit-btn').find('div:first').addClass('d-none');
    $('#loader-customer').css("display", "inline-block");
    var name = $('#name').val();
    var gender = $('#RegisterForm-gender').val();
    var race = $('#RegisterForm-race').val();
    var opt_email = $("#RegisterForm-opt-email").is(":checked");
    var opt_sms = $("#RegisterForm-opt-sms").is(":checked");

    var otp_no1 = $('#number0').val();
    var otp_no2 = $('#number1').val();
    var otp_no3 = $('#number2').val();
    var otp_no4 = $('#number3').val();
    var flagcode = $('#flag-with-code').val();
    var phNo = $('#mobile-number').val();
    var mobile_number = flagcode + phNo
    mobile_number = mobile_number?.replace(/\+/g, "")?.replace(/\s/g, "");

    var vrifydata = {
      mobile: mobile_number,
      otp: otp_no1 + otp_no2 + otp_no3 + otp_no4,
    }
    $.ajax({
      url: 'https://app.ian.ng/api/verify-otp-test',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(vrifydata),
      success: function (result) {
        // Handle the response data here
        if (result.statusCode == 200 && result.status == 'success') {
          $('.my-account-page .popup .account-otp-modal .submit-btn').find('div:first').removeClass('d-none');
          $('#loader-customer').css("display", "none");
          $('.my-account-page .popup').addClass("d-none");
          $('.my-account-page .popup').removeClass("show");
          $(".regi-login-btn").find("div:first").addClass("d-none");
          loader.css("display", "inline-block");
          var data = {
            phone: mobile_number,
            name: name,
            gender: gender,
            race: race,
            opt_email: (opt_email == true) ? '1' : '0',
            opt_sms: (opt_sms == true) ? '1' : '0',
            customer_id: __st.cid
          }
          $.ajax({
            url: 'https://app.ian.ng/api/update-details',
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function (response) {
              if (response.statusCode == 200 && response.status == 'success') {
                $(".regi-login-btn").find("div:first").removeClass("d-none");
                loader.css("display", "none");
                $('.profils-details-form-card .profile-detail-body .form-layouts #name').removeClass("otp-error");
                $('.profils-details-form-card .profile-detail-body .form-layouts .phone-with-country-code').removeClass("error-border");
                $('.profils-details-form-card .profile-detail-body .form-layouts .position-relative#select-gender').removeClass("error-border");
                $('.profils-details-form-card .profile-detail-body .form-layouts .position-relative#select-race').removeClass("error-border");
                clearInterval(intervalId);
                $('#number0').val('');
                $('#number1').val('');
                $('#number2').val('');
                $('#number3').val('');
                $('.account-profile-dashboard .account-dashboard-card-box .account-card-name p').text(name);
                $('.account-pharamcy-card .account-pharamcy-card-sections .member-card-title').text(name);
                $("#name").prop("disabled", true);
                $('.my-account-dashboard .account-profile-dashboard .profils-details-form-card .form-layouts .position-relative.phone-number-verify').addClass("pointer-event-none")
                $("#mobile-number").prop("disabled", true);
                $("#RegisterForm-gender").prop("disabled", true);
                $("#RegisterForm-race").prop("disabled", true);
                $("#RegisterForm-opt-email").prop("disabled", true);
                $("#RegisterForm-opt-sms").prop("disabled", true);
                $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .profile-cancel-btn').addClass("d-none");
                $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .regi-login-btn').addClass("d-none");
                localStorage.removeItem("mobile_number");
              } else {
                $(".regi-login-btn").find("div:first").removeClass("d-none");
                $(".my-account-dashboard .account-profile-dashboard .profils-details-form-card .profile-detail-body .mobile-no-error").removeClass("d-none");
                loader.css("display", "none");
                clearInterval(intervalId);
                $('#number0').val('');
                $('#number1').val('');
                $('#number2').val('');
                $('#number3').val('');
              }
            },
            error: function (error) {
              $(".regi-login-btn").find("div:first").removeClass("d-none");
              loader.css("display", "none");
              console.error("Error saving form data", error);
            }
          });
        } else {
          $('.my-account-page .popup .account-otp-modal .submit-btn').find('div:first').removeClass('d-none');
          $('#loader-customer').css("display", "none");
          $('.my-account-page .account-otp-modal .register-verify-form .phone-number-error.otp-verify').removeClass("d-none");
          $('.my-account-page .account-otp-modal .register-verify-form .position-relative .otp-input .otp-number').addClass("otp-error");
        }
      },
      error: function (result) {
        $('.my-account-page .popup .account-otp-modal .submit-btn').find('div:first').removeClass('d-none');
        $('#loader-customer').css("display", "none");
        $('.my-account-page .account-otp-modal .register-verify-form .phone-number-error.otp-verify').removeClass("d-none");
        $('.my-account-page .account-otp-modal .register-verify-form .position-relative .otp-input .otp-number').addClass("otp-error");
      }
    })
  });

  $('.my-account-page .popup .register-verify-form .not-recived-code a').click(function (event) {
    console.log("popup trigger");
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    $('.my-account-dashboard .account-profile-dashboard .profile-detail-btn-group .regi-login-btn').trigger('click');
    $('.register-verify-form .position-relative .not-recived-code #timer').removeClass("d-none");
    $('.register-verify-form .position-relative .not-recived-code a').addClass("d-none");
  });
  //account page end

  if (window.location.pathname == '/account/login') {
    if (window.location.hash == '#recover') {
      $('.register-page-container .register-page-bg-img').addClass('d-none');
    }
    if (window.location.hash == '#login' || window.location.hash == '') {
      $('.my-account-side-container').addClass('d-none');
    }
  }

  $('.aapharamcy-login-form form .register-page-card-form .forget-password-link').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    $('.register-page-container .register-page-bg-img').addClass('d-none');
    $('.login-page .login-mob-nav .mobnav').removeClass('d-none');
    $('.my-account-side-container').removeClass('d-none');
    window.location.href = $('.aapharamcy-login-form form .register-page-card-form .forget-password-link').attr('href');
  });

  $('.login-recover-pass-form form .regi-cancel-btn').click(function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    $('.register-page-container .register-page-bg-img').removeClass('d-none');
    $('.my-account-side-container').addClass('d-none');
    $('.login-page .login-mob-nav .mobnav').addClass('d-none');
    window.location.href = $('.login-recover-pass-form form .regi-cancel-btn').attr('href');
  });

  // ========== OLD GOOGLE LOGIN (login page) - uses deprecated gapi.auth2 ==========
  // $('.aapharamcy-login-form form .register-page-card-form .login-google-btn-open-popup').click(async function(event) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     event.stopImmediatePropagation();
  //     gapi.auth2.getAuthInstance().signIn({
  //         prompt: 'select_account'
  //     }).then(function(googleUser) {
  //         $.ajax({
  //         url: 'https://app.ian.ng/api/google-email',
  //         method: 'POST',
  //         contentType: 'application/json',
  //         data: JSON.stringify({email: googleUser.getBasicProfile().getEmail()}),
  //         success: function(result) {
  //           if(result.statusCode == 200 && result.status == 'success'){
  //             $('.aapharamcy-login-form form #CustomerEmail').attr('name','');
  //             $('.aapharamcy-login-form form #password-input').attr('name','');
  //             $('<input>').attr('type','hidden').attr('name','customer[email]').attr('value',result?.data?.email).insertAfter('.aapharamcy-login-form form #CustomerEmail');
  //             $('<input>').attr('type','hidden').attr('name','customer[password]').attr('value',result?.data?.password).insertAfter('.aapharamcy-login-form form #password-input');
  //             $('.aapharamcy-login-form .register-page-card-form .regi-login-btn').trigger('click');
  //           } else {
  //             $('.aapharamcy-login-form form .error-banner.google-login').removeClass("d-none");
  //           }
  //         },
  //         error: function(result) {
  //           $('.aapharamcy-login-form .register-page-card-form .regi-login-btn').trigger('click');
  //         }
  //       })
  //     }).catch((error) => {
  //          $('.aapharamcy-login-form .register-page-card-form .regi-login-btn').trigger('click');
  //     });    
  // });
  // ========== END OLD GOOGLE LOGIN (login page) ==========

  // ========== NEW GOOGLE LOGIN (login page) - uses Google Identity Services ==========
  $('.aapharamcy-login-form form .register-page-card-form .login-google-btn-open-popup').click(async function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const client = google.accounts.oauth2.initTokenClient({
      // client_id: '464627350126-8csv0fvlqsng3lkst0hvuuhffbkkee15.apps.googleusercontent.com',
      client_id: '670609129194-o8ckki00dg1p7d3lfql4ooj3o2cvagvu.apps.googleusercontent.com',
      scope: 'email profile',
      callback: function (tokenResponse) {
        if (tokenResponse.error) {
          console.error('Google auth error:', tokenResponse.error);
          $('.aapharamcy-login-form form .error-banner.google-login').removeClass("d-none");
          return;
        }

        fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: 'Bearer ' + tokenResponse.access_token }
        })
          .then(function (res) { return res.json(); })
          .then(function (userInfo) {
            $.ajax({
              url: 'https://app.ian.ng/api/google-email',
              method: 'POST',
              contentType: 'application/json',
              data: JSON.stringify({ email: userInfo.email }),
              success: function (result) {
                if (result.statusCode == 200 && result.status == 'success' && result.data && result.data.email) {
                  $('.aapharamcy-login-form form #CustomerEmail').attr('name', '');
                  $('.aapharamcy-login-form form #password-input').attr('name', '');
                  $('<input>').attr('type', 'hidden').attr('name', 'customer[email]').attr('value', result?.data?.email).insertAfter('.aapharamcy-login-form form #CustomerEmail');
                  $('<input>').attr('type', 'hidden').attr('name', 'customer[password]').attr('value', result?.data?.password).insertAfter('.aapharamcy-login-form form #password-input');
                  $('.aapharamcy-login-form .register-page-card-form .regi-login-btn').trigger('click');
                } else {
                  console.log('Google login failed, API response:', result);
                  $('.aapharamcy-login-form form .error-banner.google-login').removeClass("d-none");

                }
              },
              error: function (result) {
                $('.aapharamcy-login-form form .error-banner.google-login').removeClass("d-none");
              }
            });
          })
          .catch(function (error) {
            console.error('Failed to fetch user info:', error);
            $('.aapharamcy-login-form form .error-banner.google-login').removeClass("d-none");
          });
      }
    });

    client.requestAccessToken({ prompt: 'select_account' });
  });
  // ========== END NEW GOOGLE LOGIN (login page) ==========

  // ========== OLD GOOGLE REGISTER (register page) - uses deprecated gapi.auth2 ==========
  // $('.register-google-btn-open-popup').on( "click", function(event) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //     event.stopImmediatePropagation();
  //     gapi.auth2.getAuthInstance().signIn({
  //         prompt: 'select_account'
  //     }).then(function(googleUser) {
  //       var phoneNumber = getCookie("mobileNumber");
  //       $.ajax({
  //         url: 'https://app.ian.ng/api/google-email',
  //         method: 'POST',
  //         contentType: 'application/json',
  //         data: JSON.stringify({email: googleUser.getBasicProfile().getEmail(), mobile_no : phoneNumber }),
  //         success: function(result) {
  //           if(result.statusCode == 200 && result.message == 'No data found'){
  //             $('.register-page-card form .password-google-login-hide').addClass('d-none');
  //             $('.register-form-card form .register-google-btn-open-popup').addClass('d-none');
  //             var form = $('.register-page-card form');
  //             const userEmail = googleUser.getBasicProfile().getEmail();
  //             const user_name = googleUser.getBasicProfile().getName();
  //             form.find('#RegisterForm-FirstName').attr('disabled',true);
  //             form.find('#RegisterForm-FirstName').val(user_name);
  //             form.find('#RegisterForm-email').attr('disabled',true);
  //             form.find('#RegisterForm-email').val(userEmail);
  //             if(result?.data?.mobile){
  //                 let datas = result?.data;
  //                 let genderData =  (datas?.gender == 'M') ? 'Male' : 'Female';
  //                 form.find('#RegisterForm-gender').val(genderData);
  //                 if(form.find('#RegisterForm-gender').val()){
  //                   $(".register-page-card-body .form-layouts #select2-RegisterForm-gender-container").text(genderData); 
  //                 }
  //                 form.find('#RegisterForm-datepicker').val(datas?.DOB);
  //                 form.find('#RegisterForm-race').val(datas?.race);
  //                 if(form.find('#RegisterForm-race').val() != null){
  //                   $(".register-page-card-body .form-layouts #select2-RegisterForm-race-container").text(datas?.race); 
  //                 }
  //             }
  //           } else {
  //             $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");
  //           }
  //         },
  //         error: function(result) {
  //           $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");
  //         }
  //       })
  //     }).catch((error) => {
  //         $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");
  //     });    
  // });
  // ========== END OLD GOOGLE REGISTER (register page) ==========

  // ========== NEW GOOGLE REGISTER (register page) - uses Google Identity Services ==========
  $('.register-google-btn-open-popup').on("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const client = google.accounts.oauth2.initTokenClient({
      client_id: '464627350126-8csv0fvlqsng3lkst0hvuuhffbkkee15.apps.googleusercontent.com',
      scope: 'email profile',
      callback: function (tokenResponse) {
        if (tokenResponse.error) {
          console.error('Google auth error:', tokenResponse.error);
          $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");
          return;
        }

        fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: 'Bearer ' + tokenResponse.access_token }
        })
          .then(function (res) { return res.json(); })
          .then(function (userInfo) {
            var phoneNumber = getCookie("mobileNumber");
            $.ajax({
              url: 'https://app.ian.ng/api/google-email',
              method: 'POST',
              contentType: 'application/json',
              data: JSON.stringify({ email: userInfo.email, mobile_no: phoneNumber }),
              success: function (result) {
                if (result.statusCode == 200 && result.message == 'No data found') {
                  $('.register-page-card form .password-google-login-hide').addClass('d-none');
                  $('.register-form-card form .register-google-btn-open-popup').addClass('d-none');
                  var form = $('.register-page-card form');
                  form.find('#RegisterForm-FirstName').attr('disabled', true);
                  form.find('#RegisterForm-FirstName').val(userInfo.name);
                  form.find('#RegisterForm-email').attr('disabled', true);
                  form.find('#RegisterForm-email').val(userInfo.email);
                  if (result?.data?.mobile) {
                    let datas = result?.data;
                    let genderData = (datas?.gender == 'M') ? 'Male' : 'Female';
                    form.find('#RegisterForm-gender').val(genderData);
                    if (form.find('#RegisterForm-gender').val()) {
                      $(".register-page-card-body .form-layouts #select2-RegisterForm-gender-container").text(genderData);
                    }
                    form.find('#RegisterForm-datepicker').val(datas?.DOB);
                    form.find('#RegisterForm-race').val(datas?.race);
                    if (form.find('#RegisterForm-race').val() != null) {
                      $(".register-page-card-body .form-layouts #select2-RegisterForm-race-container").text(datas?.race);
                    }
                  }
                } else {
                  $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");
                }
              },
              error: function (result) {
                $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");
              }
            });
          })
          .catch(function (error) {
            console.error('Failed to fetch user info:', error);
            $('.register-page-card-body .form-layouts .reg-mismatch-email').removeClass("d-none");
          });
      }
    });

    client.requestAccessToken({ prompt: 'select_account' });
  });
  // ========== END NEW GOOGLE REGISTER (register page) ==========

  // ========== GOOGLE LOGIN MIGRATION INTERCEPTOR ==========
  // Xử lý kiểm tra tài khoản Google chưa đổi pass bằng cách dựa vào lỗi đăng nhập của Shopify

  // 1. Lưu lại email khi khách hàng bấm nút Sign In
  $('#customer_login').on('submit', function (event) {
    var emailInput = $(this).find('#CustomerEmail').val();
    if (emailInput) {
      sessionStorage.setItem('last_login_attempt_email', emailInput);
    }
  });

  // 2. Chạy hàm kiểm tra ngay khi trang load xong
  // Nếu có thông báo sai mật khẩu từ Shopify, ta lấy email vừa lưu gọi thử API google-email
  if ($('.default-login-error').length > 0) {
    var failedEmail = sessionStorage.getItem('last_login_attempt_email');
    if (failedEmail) {
      $.ajax({
        url: 'https://app.ian.ng/api/google-email',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ email: failedEmail }),
        success: function (result) {
          // Nếu API trả lại thông tin user + pass có nghĩa là khách này từng là Google user
          if (result && result.statusCode == 200 && result.data && result.data.password) {
            var msgHtml = '<p style="margin-top: 1.5rem; font-size: 1.4rem; padding-top: 1rem; border-top: 1px solid rgba(0,0,0,0.1);padding-inline-start: 2.4rem; padding-inline-end: 0.5rem;">' +
              'Your account is connected to Google. Please <a href="#recover" style="text-decoration: underline; font-weight: bold;">reset your password</a> to log in.' +
              '</p>';
            $('.default-login-error').append(msgHtml);

            // Xóa email lưu tạm để không lặp lại
            sessionStorage.removeItem('last_login_attempt_email');
          }
        }
      });
    }
  }
  // ========== END GOOGLE LOGIN MIGRATION INTERCEPTOR ==========
});